import { render, staticRenderFns } from "./ExpansionPanelWrapper.vue?vue&type=template&id=04205908&scoped=true"
import script from "./ExpansionPanelWrapper.vue?vue&type=script&lang=js"
export * from "./ExpansionPanelWrapper.vue?vue&type=script&lang=js"
import style0 from "./ExpansionPanelWrapper.vue?vue&type=style&index=0&id=04205908&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04205908",
  null
  
)

export default component.exports